import React, { useContext, useEffect, useState } from 'react';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import MultiSelectEntity from '../RefineSearch/MultiSelectEntity';
import Popup from '../Common/Popup';

/**
 * The `ExitStatusFilter` function is a React component that renders a filter for exit status options,
 * allowing the user to select multiple options.
 * @returns a JSX element.
 */
function ExitStatusFilter({ ExitStatusOptions, setExitStatusOptions, customPathname, dataPath, label = "Exit Status", isPopupOpen, setIsPopupOpen }) {
    const { exitStatusResponseData, refineSearchFilters } = useContext(PeFilterContext);
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;

    useEffect(() => {
        const industryIds = refineSearchFilters[customPathname]?.exitStatus?.map(value => value.id) ?? [];
        setExitStatusOptions(exitStatusResponseData[dataPath]?.map(industry => ({ ...industry, isChecked: industryIds.includes(industry.id) })));
    }, [exitStatusResponseData, customPathname, refineSearchFilters, setExitStatusOptions, dataPath]);

    const handleExitStatusChange = (e) => {
        const { name, checked, id, filteredIds } = e.target;
    
        if (name === "allSelect") {
            let currentExitStatus = ExitStatusOptions.map((exitStatus) =>
                ({ ...exitStatus, isChecked: checked })
            );
            setExitStatusOptions(currentExitStatus);
        } else if (name === "filteredSelect" && filteredIds) {
            let currentExitStatus = ExitStatusOptions.map((exitStatus) => {
                if (filteredIds.includes(exitStatus.id)) {
                    return { ...exitStatus, isChecked: checked };
                }
                return exitStatus;
            });
            setExitStatusOptions(currentExitStatus);
        } else {
            let currentExitStatus = ExitStatusOptions.map((exitStatus) =>
                exitStatus.id == id ? { ...exitStatus, isChecked: checked } : exitStatus
            );
            setExitStatusOptions(currentExitStatus);
        }
    };

    const selectedExitStatusCount = ExitStatusOptions?.filter(option => option.isChecked)?.length ?? 0;

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-md px-4 py-1 text-gray-500 hover:bg-gray-100  text-sm shadow-md border border-gray-300 text-left flex items-center justify-between w-full md:w-[90%]"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2">{label} <span className="opacity-60 ml-2 text-xs text-ellipsis">e.g. {ExitStatusOptions.slice(0,2).map(item => item.name).join(', ')}</span></span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {selectedExitStatusCount > 0 && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            {selectedExitStatusCount}
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)}>
                    <div className="p-4">
                        <MultiSelectEntity
                            handleEntityChange={handleExitStatusChange}
                            primaryEntity={ExitStatusOptions}
                            showAll={false}
                            searchBox={false}
                        />
                    </div>
                </Popup>
            )}
        </div>
    );
}

export default ExitStatusFilter;
